import { Routes } from '@angular/router';

import { ChannelAdminPage } from './channel-admin.page';

export const ChannelAdminPageRoutes: Routes = [
  {
    path: '',
    component: ChannelAdminPage,
    children: [
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full',
      },
      {
        path: 'overview',
        loadComponent: () =>
          import('./channel-admin-overview/channel-admin-overview.page').then((m) => m.ChannelAdminOverviewPage),
      },
      {
        path: 'members',
        loadComponent: () =>
          import('./channel-admin-members/channel-admin-members.page').then((m) => m.ChannelAdminMembersPage),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./channel-admin-settings/channel-admin-settings.page').then((m) => m.ChannelAdminSettingsPage),
      },
    ],
  },
];
